export default {
  items: [
    {
      name: "Welcome",
      url: "/holding",
      icon: "far fa-handshake",
      auth: undefined,
    },
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fas fa-tachometer-alt",
      auth: "Order.Read",
    },

    {
      name: "easyJet Tracking",
      icon: "fas fa-shipping-fast",
      auth: "EZYLogisticsTracking.Read",
      toggleState: "toggleEasyJet",
      subMenu: [
        {
          name: "T Orders",
          url: "/easyjetTracking",
          icon: "fas fa-truck-loading",
          auth: "EZYLogisticsTracking.Read",
        },
        {
          name: "Shipments",
          feature: "shipmentView",
          url: "/easyJetTrackingShipments",
          icon: "fas fa-ship",
          auth: "EZYLogisticsTracking.Read",
        },
      ],
    },
    {
      name: "Orders",
      url: "/orders/sales",
      icon: "fas fa-shopping-bag",
      auth: "Order.Read",
    },
    {
      name: "Exchanges",
      url: "/exchanges",
      icon: "fas fa-exchange-alt",
      auth: "ExchangeOrderRequest.Read",
    },
    {
      name: "Repairs",
      url: "/orders/adhoc",
      icon: "fas fa-tools",
      auth: "RepairOrderRequest.Read",
    },
    {
      name: "Eventory",
      url: "/eventory",
      icon: "fas fa-shopping-basket",
      auth: undefined,
    },

    {
      name: "Invoices",
      url: "/invoices",
      icon: "fas fa-file-invoice-dollar",
      auth: "Invoices.Read", //FROM swagger get /api/Identity  /
    },
    {
      name: "Users",
      url: "/users",
      icon: "fas fa-users",
      auth: "UserPermission.Read", //FROM swagger get /api/Identity  /
    },

    {
      name: "Analytics & AI",
      url: "/bi",
      icon: "fas fa-chart-bar",
      auth: "PowerBiReport.Read", //FROM swagger get /api/Identity  /
    },
    {
      name: "Internal Modules",
      url: "/internal",
      icon: "fas fa-id-card",
      auth: "Internal",
    },
    // {
    //   name: "Updates",
    //   url: "/updates",
    //   icon: "fas fa-code",
    //   auth: "Feature.Write",
    // },

    {
      name: "Admin",
      url: "/admin",
      icon: "fas fa-users-cog",
      auth: [
        "CompanyContact.Read",
        "CompanyContact.Write",

        "CompanySites.Read",

        "CustomerMapping.Read",
        "CustomerMapping.Write",

        "UserPermission.Read",
        "UserPermission.Write",

        "CompanyContactAll.Read",
        "CompanyContactAll.Write",

        "ContractAllCompanies.Read",
      ],
    },
  ],
};
